import React, { useState } from 'react';

import {
  Box,
  Text,
  Input,
  FormControl,
  FormLabel,
  VStack,
  Textarea,
} from '@chakra-ui/react';

import { useColors } from './colors';

const ItemSupplierDetails = ({ listing, onUpdate }) => {
  const [supplierItemInfo, setSupplierItemInfo] = useState(
    listing?.supplier?.description || '',
  );

  const {
    bgColor,
    borderColor,
    headingColor,
    subTextColor: labelColor,
    hoverBg: readOnlyBg,
    inputColor: readOnlyColor,
  } = useColors();

  const supplierName =
    listing?.supplier?.altName || listing?.supplier?.name || 'Supplier Not Selected';

  return (
    <Box
      bg={bgColor}
      borderRadius="xl"
      p={6}
      border="1px solid"
      borderColor={borderColor}
      w="450px"
    >
      <Text fontSize="xl" fontWeight="semibold" color={headingColor} mb={6}>
        Item Supplier Details ({supplierName})
      </Text>

      <VStack spacing={5} align="stretch">
        {/* Disabled Fields */}
        <FormControl>
          <FormLabel fontSize="sm" fontWeight="semibold" color={labelColor} mb={2}>
            Supplier Identifier/SKU
          </FormLabel>
          <Input
            value={listing?.supplier?.supplierIdentifier || ''}
            isReadOnly
            bg={readOnlyBg}
            color={readOnlyColor}
            cursor="not-allowed"
            size="md"
            borderRadius="md"
            placeholder="--"
          />
        </FormControl>

        <FormControl>
          <FormLabel fontSize="sm" fontWeight="semibold" color={labelColor} mb={2}>
            OEM
          </FormLabel>
          <Input
            value={listing?.supplier?.oem || ''}
            isReadOnly
            bg={readOnlyBg}
            color={readOnlyColor}
            cursor="not-allowed"
            size="md"
            borderRadius="md"
            placeholder="--"
          />
        </FormControl>

        <FormControl>
          <FormLabel fontSize="sm" fontWeight="semibold" color={labelColor} mb={2}>
            Partslink
          </FormLabel>
          <Input
            value={listing?.supplier?.partslink || ''}
            isReadOnly
            bg={readOnlyBg}
            color={readOnlyColor}
            cursor="not-allowed"
            size="md"
            borderRadius="md"
            placeholder="--"
          />
        </FormControl>

        <FormControl>
          <FormLabel fontSize="sm" fontWeight="semibold" color={labelColor} mb={2}>
            Supplier Item Info
          </FormLabel>
          <Textarea
            isReadOnly
            value={supplierItemInfo}
            minRows={3}
            resize="vertical"
            borderRadius="md"
            bg={readOnlyBg}
            color={readOnlyColor}
            placeholder="--"
          />
        </FormControl>
      </VStack>
    </Box>
  );
};

export default ItemSupplierDetails;
